import { render, staticRenderFns } from "./UserBlocked.vue?vue&type=template&id=cecc294c&scoped=true&"
import script from "./UserBlocked.vue?vue&type=script&lang=js&"
export * from "./UserBlocked.vue?vue&type=script&lang=js&"
import style0 from "./UserBlocked.vue?vue&type=style&index=0&id=cecc294c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecc294c",
  null
  
)

export default component.exports